// Marketing · Campañas (montado en /marketing/campanas/*): lista, asistente/editor y estadísticas.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { CampaignDetail } from "./campaigns/CampaignDetail.tsx";
import { CampaignList } from "./campaigns/CampaignList.tsx";
import { CampaignWizard } from "./campaigns/CampaignWizard.tsx";

export function MktCampaigns(): JSX.Element {
  return (
    <Routes>
      <Route index element={<CampaignList />} />
      <Route path=":id/editar" element={<CampaignWizard />} />
      <Route path=":id" element={<CampaignDetail />} />
    </Routes>
  );
}
